import type { GhostTag } from '~/types/ghost-tag'
import type { GhostPagesResponse } from '~/types/ghost-content'

export default () => {
  const config = useRuntimeConfig()
  const getGhostPageContent = async ({ tag, slug }: { tag: GhostTag; slug: string }) => {
    const data = await $fetch<GhostPagesResponse>(
      `${config.public.ghost.apiUrl}/pages?${new URLSearchParams({
        key: config.public.ghost.apiKey,
        limit: '1',
        filter: `tag:${tag}+slug:${slug}`
      })}`
    )
    const pages = data?.pages

    if (!pages) return

    return pages[0]
  }

  return {
    getGhostPageContent
  }
}
